class HtmlFontSize {
  constructor(designWidth = 1024, baseFontSize = 100) {
    this.designWidth = designWidth;
    this.baseFontSize = baseFontSize;
  }

  getProportion() {
    return document.body.clientWidth / this.designWidth;
  }

  setFontSize() {
    const rootFontSize = this.getProportion() * this.baseFontSize;
    const htmlEl = document.querySelector("html");
    htmlEl.style.fontSize = `${rootFontSize}px`;
  }

  init() {
    this.setFontSize();
    window.addEventListener("resize", this.setFontSize.bind(this), false);
  }
}

new HtmlFontSize().init();
